// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2enhT","type":"styles_type__2ccKR","choices":"styles_choices__z9b0R"};